import { useState, useEffect } from 'react';
import keyboard from 'keymaster';

let counter = -1;

export default (name = 'keys', active = false, keys = {}) => {
  const [guid, setGuid] = useState(null);

  useEffect(() => {
    counter += 1;
    setGuid(`${name}-${counter}`);

    return function cleanup() {
      counter -= 1;
    };
  }, [name]);

  useEffect(() => {
    if (guid !== null) {
      Object.keys(keys).forEach(key => {
        keyboard(key, guid, keys[key]);
      });
    }

    return function cleanup() {
      keyboard.deleteScope(guid);
    };
  }, [guid, keys]);

  useEffect(() => {
    if (active) {
      keyboard.setScope(guid);
    } else {
      if (keyboard.getScope() === guid) {
        keyboard.setScope('all');
      }
    }
  }, [active, guid]);
};
